import { BeneficiaryType } from '@seapoint/server/enums';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';

type GetAccountDetailsArgs = {
  type: BeneficiaryType;
  accountNumber?: string;
  sortCode?: string;
  iban?: string;
};

export const getAccountDetails = ({ type, accountNumber, sortCode, iban }: GetAccountDetailsArgs) => {
  switch (type) {
    case BeneficiaryType.IBAN:
      if (!iban) {
        throw new Error('IBAN is required');
      }

      return {
        beneficiaryType: type,
        iban,
      };
    case BeneficiaryType.SCAN:
      if (!accountNumber || !sortCode) {
        throw new Error('Account number and sort code are required');
      }

      return {
        beneficiaryType: type,
        accountNumber,
        sortCode,
      };
    default:
      return exhaustiveCheck(type);
  }
};
